module.exports = __webpack_public_path__ + "static/media/duplicateIcon.44deb202.svg";